import PRODUCT_CONSTANT from './../product/product.constant';

export default [{
  state: 'home',
  config: {
    url: `/?${PRODUCT_CONSTANT.FILTER_PARAMS}`,
    component: 'home',
    reloadOnSearch: false,
  },
}];



// WEBPACK FOOTER //
// ./src/app/home/home.routes.js